import React            from 'react'
import { BlogsCard }    from './index'

const Blogs = () => {
    return (
        <div className="landing-container-blogs">
            <h1>Bloglar</h1> 
            <div className="blogs-list">
                <BlogsCard />    
                <BlogsCard />    
                <BlogsCard />    
                <BlogsCard /> 
            </div>
        </div>
    )
}

export default Blogs
